<template lang="pug">
transition(name="modal-fade")
  .modal-backdrop
    .modal(:class="{'m-err' : type=='delete' }")
      .m-ico 
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="60" height="60" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#a43246"><path d="M86,14.33333c-39.5815,0 -71.66667,32.08517 -71.66667,71.66667c0,39.5815 32.08517,71.66667 71.66667,71.66667c39.5815,0 71.66667,-32.08517 71.66667,-71.66667c0,-39.5815 -32.08517,-71.66667 -71.66667,-71.66667zM93.16667,121.83333h-14.33333v-14.33333h14.33333zM93.16667,93.16667h-14.33333v-43h14.33333z"></path></g></g></svg>
        //- <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="60" height="60" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#a43246"><path d="M159.3795,132.23217l-63.04517,-104.88417c-2.20017,-3.66217 -6.063,-5.848 -10.33433,-5.848c-4.27133,0 -8.13417,2.18583 -10.32717,5.84083l-63.05233,104.89133c-2.236,3.7195 -2.29333,8.37067 -0.15767,12.1475c2.1285,3.77683 6.149,6.12033 10.492,6.12033h126.0975c4.33583,0 8.3635,-2.3435 10.492,-6.12033c2.13567,-3.77683 2.07117,-8.428 -0.16483,-12.1475zM93.16667,129h-14.33333v-14.33333h14.33333zM93.16667,100.33333h-14.33333v-35.83333h14.33333z"></path></g></g></svg>
        //- <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="60" height="60" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#a43246"><path d="M86,7.16667l-64.5,28.66667c0,0 0,28.66667 0,43c0,56.115 46.14617,82.31633 64.5,86c18.35383,-3.68367 64.5,-29.885 64.5,-86c0,-14.33333 0,-43 0,-43zM93.16667,129h-14.33333v-14.33333h14.33333zM93.16667,100.33333h-14.33333v-57.33333h14.33333z"></path></g></g></svg>
      .m-msg {{ $t('modal.msg.'+ text ) }}
      .m-btn-container 
        b-button.m-s-button(@click="validate" :class="{ 'm-e-button' : type=='delete' }") {{ $t('modal.btn.'+ type ) }}
        b-button.m-s-button(@click="close") {{ $t('modal.btn.cancel' ) }}
</template>

<script>
  export default {
    name: 'Modal',
    props: {
      type: String,
      text: String,
    },
    methods: {
      close() {
        this.$emit('close');
      },
      validate(){
        this.$emit('validate');
      }
    },
  };
</script>

<style>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 1;
}

.modal {
  background: #FFFFFF;
  box-shadow: 0px 0px 66px 1px #26252578;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  max-height: 180px;
  max-width: 475px;
  top: unset !important;
  left: unset !important;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
}

@media  (max-width: 576px) { 
  .modal {
    max-width: 345px;
  }
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity .5s ease;
}
.m-ico{
  padding: 2px;
  margin-top: -5px;
}
.m-msg{
  margin-bottom: 8px;
  padding: 5px;
  font-weight: 600;
  color: #565656;
  text-align: center;
}
.m-s-button{
  padding: 5px 30px;
  background-color: white;
  margin: 0 2px;
  border: 1px solid #a43246;
  border-radius: 5px;
  color: #a43246;
  font-weight: 600;
  min-width: 141px;
}
.m-s-button:hover{
  border-color: #a43246 !important;
  color: white !important;
}
/* .m-err .m-e-button{
  border-color: #c50e0e !important;
  color: #c50e0e !important;
} */
.m-err .m-e-button:hover{
  border-color: #c50e0e !important;
  background-color: #c50e0e !important;
  color: white !important;
}
</style>